import AuthService from './AuthService';

class ConversationHistoryService {
    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_CHATBOT_API_URL;
    }

    async getConversations(params = {}) {
        const token = AuthService.getAccessToken();
        const loginAs = AuthService.getLoginAs();
        const query = new URLSearchParams();
        if (params.page) query.set('page', params.page);
        if (params.pageSize) query.set('pageSize', params.pageSize);
        if (params.startDate) query.set('startDate', params.startDate);
        if (params.endDate) query.set('endDate', params.endDate);
        if (params.search) query.set('search', params.search);
        if (params.chatbotId) query.set('chatbotId', params.chatbotId);
        if (loginAs) query.set('loginAs', loginAs);
        const url = `${this.apiBaseUrl}private/conversations/history?${query.toString()}`;
        const response = await fetch(url, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
    }

    async getConversationDetail(conversationId) {
        const token = AuthService.getAccessToken();
        const loginAs = AuthService.getLoginAs();
        const query = loginAs ? `?loginAs=${loginAs}` : '';
        const url = `${this.apiBaseUrl}private/conversations/history/${conversationId}${query}`;
        const response = await fetch(url, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
    }
}

const conversationHistoryService = new ConversationHistoryService();
export default conversationHistoryService;
